"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const coerceValueToBoolean_1 = __importDefault(require("./coerceValueToBoolean"));
const normalizeBooleanOptions = (options) => lodash_1.map(options, option => lodash_1.isString(option)
    ? { label: lodash_1.capitalize(option), value: coerceValueToBoolean_1.default(option) }
    : Object.assign(Object.assign({}, option), { value: coerceValueToBoolean_1.default(option.value) }));
exports.default = normalizeBooleanOptions;
